import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import PagesLayout from 'layout/Pages';
import SimpleLayout from 'layout/Simple';

import { SimpleLayoutType } from 'config';

// pages routing
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));



// NOVO: Central de Dispositivos
const DevicesCenter = Loadable(lazy(() => import('pages/security/devices-center')));

// NOVO: Configurações da Conta
const AccountSettings = Loadable(lazy(() => import('pages/account')));

// NOVO: Colaboradores
const UsersPage = Loadable(lazy(() => import('pages/users')));
const SensitiveFieldsPage = Loadable(lazy(() => import('pages/sensitive-fields')));
// NOVO: Funções (roles)
const RolesPage = Loadable(lazy(() => import('pages/roles')));
// NOVO: Departamentos
const DepartmentsPage = Loadable(lazy(() => import('pages/departments')));

// NOVO: Empresa
const CompanyPage = Loadable(lazy(() => import('pages/company')));

// NOVO: Clientes
const ClientsPage = Loadable(lazy(() => import('pages/clients')));
const NewClientPage = Loadable(lazy(() => import('pages/clients/new')));
const ClientDetailsPage = Loadable(lazy(() => import('pages/clients/[id]')));
const EditClientPage = Loadable(lazy(() => import('pages/clients/[id]/edit')));

// NOVO: Projetos
const ProjectsPage = Loadable(lazy(() => import('pages/projects')));

// NOVO: Escopos
const ScopesPage = Loadable(lazy(() => import('pages/scopes')));
const NewScopePage = Loadable(lazy(() => import('pages/scopes/new')));
const ScopeViewPage = Loadable(lazy(() => import('pages/scopes/[id]')));
const EditScopePage = Loadable(lazy(() => import('pages/scopes/[id]/edit')));

// NOVO: Bloqueios de Conta
const AccountBlocksPage = Loadable(lazy(() => import('pages/security/account-blocks')));

// NOVO: Uso da IA

// NOVO: Contratos
const ContractTemplatesPage = Loadable(lazy(() => import('pages/contracts/templates')));
const ContractsPage = Loadable(lazy(() => import('pages/contracts')));
const NewContractPage = Loadable(lazy(() => import('pages/contracts/new')));
const ContractViewPage = Loadable(lazy(() => import('pages/contracts/[id]')));
const EditContractPage = Loadable(lazy(() => import('pages/contracts/[id]/edit')));

// NOVO: Pedidos
const OrdersPage = Loadable(lazy(() => import('pages/orders')));
const NewOrderPage = Loadable(lazy(() => import('pages/orders/new')));
const EditOrderPage = Loadable(lazy(() => import('pages/orders/[id]/edit')));

// NOVO: Logística
const LogisticsPage = Loadable(lazy(() => import('pages/logistics')));

// NOVO: Armazém
const WarehouseMapPage = Loadable(lazy(() => import('pages/warehouse')));
// Faturamento (pedidos em faturamento)
const BillingPage = Loadable(lazy(() => import('pages/billing')));
// Gerenciamento de taxas
const TaxesPage = Loadable(lazy(() => import('pages/taxes')));
const CatalogHealthPage = Loadable(lazy(() => import('pages/catalog-health')));
const AssistantPage = Loadable(lazy(() => import('pages/assistant')));

// NOVO: Calibragem de Etiquetas
const LabelCalibrationPage = Loadable(lazy(() => import('pages/label-calibration')));

// NOVO: Produtos
const ProductsPage = Loadable(lazy(() => import('pages/products')));
const NewProductPage = Loadable(lazy(() => import('pages/products/new')));
const EditProductPage = Loadable(lazy(() => import('pages/products/[id]/edit')));

// NOVO: Financeiro

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        //{
        //  path: 'devices',
        //  element: <DevicesCenter />
        //},
        //// NOVO: Bloqueios de Conta
        //{
        //  path: 'blocks',
        //  element: <AccountBlocksPage />
        //},
        {
          path: 'account',
          element: <AccountSettings />
        },
        {
          path: 'users',
          element: <UsersPage />
        },
        {
          path: 'roles',
          element: <RolesPage />
        },
        {
          path: 'departments',
          element: <DepartmentsPage />
        },
        {
          path: 'company',
          element: <CompanyPage />
        },
        {
          path: 'clients',
          element: <ClientsPage />
        },
        {
          path: 'clients/new',
          element: <NewClientPage />
        },
        {
          path: 'clients/:id',
          element: <ClientDetailsPage />
        },
        {
          path: 'clients/:id/edit',
          element: <EditClientPage />
        },
        {
          path: 'projects',
          element: <ProjectsPage />
        },
        {
          path: 'scopes',
          element: <ScopesPage />
        },
        {
          path: 'scopes/new',
          element: <NewScopePage />
        },
        {
          path: 'scopes/:id',
          element: <ScopeViewPage />
        },
        {
          path: 'scopes/:id/edit',
          element: <EditScopePage />
        },
        {
          path: 'sensitive-fields',
          element: <SensitiveFieldsPage />
        },
        // NOVO: Contratos
        {
          path: 'contracts/templates',
          element: <ContractTemplatesPage />
        },
        {
          path: 'contracts/new',
          element: <NewContractPage />
        },
        {
          path: 'contracts/:id',
          element: <ContractViewPage />
        },
        {
          path: 'contracts/:id/edit',
          element: <EditContractPage />
        },
        {
          path: 'contracts',
          element: <ContractsPage />
        },
        // NOVO: Pedidos
        {
          path: 'orders',
          element: <OrdersPage />
        },
        {
          path: 'orders/new',
          element: <NewOrderPage />
        },
        {
          path: 'orders/:id/edit',
          element: <EditOrderPage />
        },
        {
          // :id aceita um uuid de pedido ou o literal "latest" (pedido mais recente do
          // usuário) — ver OrdersList.tsx. Usado pelo link "Ver status do pedido" nos
          // e-mails de atualização de status.
          path: 'orders/:id/timeline',
          element: <OrdersPage />
        },
        // NOVO: Logística
        {
          path: 'logistics',
          element: <LogisticsPage />
        },
        // NOVO: Armazém
        {
          path: 'warehouse-map',
          element: <WarehouseMapPage />
        },
        // Faturamento
        {
          path: 'billing',
          element: <BillingPage />
        },
        {
          path: 'taxes',
          element: <TaxesPage />
        },
        {
          path: 'catalog-health',
          element: <CatalogHealthPage />
        },
        {
          path: 'assistant',
          element: <AssistantPage />
        },
        {
          path: 'products',
          element: <ProductsPage />
        },
        {
          path: 'products/new',
          element: <NewProductPage />
        },
        {
          path: 'products/:id/edit',
          element: <EditProductPage />
        },
        {
          path: 'label-calibration',
          element: <LabelCalibrationPage />
        }
      ]
    },
    {
      path: '/maintenance',
      element: <PagesLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        },
        {
          path: 'under-construction',
          element: <MaintenanceUnderConstruction />
        },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />
        }
      ]
    },

  ]
};

export default MainRoutes;
